import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" stroke="#979797" strokeWidth="1.5">
      <path d="M9.6.504L9.6 18.696M.504 9.6L18.696 9.6" transform="translate(2.4 2.4)" />
    </g>
  </svg>
);
